import Phaser from 'phaser';
import { ResourceManager, ALL_RESOURCES, RESOURCE_INFO } from '../systems/ResourceManager';
import { SpriteRenderer } from '../rendering/SpriteRenderer';
import { getResourceIconId } from '../utils/IconHelper';
import { GAME_W, GAME_H, GAME_CX } from '../utils/MobileHelper';
import { FONT_BODY } from '../utils/Typography';

// === BANDEAU DE RESSOURCES ===
// Affiché en bas des scènes camp. Montre les 5 ressources avec icônes SVG, noms et quantités.

const BANNER_H = 28;
const BANNER_Y = GAME_H - BANNER_H; // en bas de l'écran

export class ResourceBanner {
  private texts: Phaser.GameObjects.Text[] = [];

  constructor(
    private scene: Phaser.Scene,
    private resources: ResourceManager,
  ) {
    this.draw();
  }

  private draw(): void {
    // Fond du bandeau
    this.scene.add.rectangle(GAME_CX, BANNER_Y + BANNER_H / 2, GAME_W, BANNER_H, 0x0d1117).setDepth(50);

    const stock = this.resources.getAll();
    const _mobBanner = GAME_W < 500;
    const startX = _mobBanner ? 8 : 80;
    const spacing = _mobBanner ? 80 : 140;

    for (let i = 0; i < ALL_RESOURCES.length; i++) {
      const type = ALL_RESOURCES[i];
      const info = RESOURCE_INFO[type];
      const x = startX + i * spacing;

      // Icône SVG ou fallback emoji
      const iconKey = SpriteRenderer.iconKey(getResourceIconId(type));
      const hasIcon = this.scene.textures.exists(iconKey);
      if (hasIcon) {
        this.scene.add.sprite(x, BANNER_Y + BANNER_H / 2, iconKey).setDepth(51);
      }

      // Nom abrégé + quantité (ex: "Bois: 5")
      const label = hasIcon
        ? `${info.name}: ${stock[type]}`
        : `${info.emoji} ${info.name}: ${stock[type]}`;
      const text = this.scene.add.text(x + 12, BANNER_Y + BANNER_H / 2, label, {
        fontSize: '11px',
        color: info.rarity === 'rare' ? '#f1c40f' : '#bdc3c7',
        fontFamily: FONT_BODY,
      }).setOrigin(0, 0.5).setDepth(51);
      this.texts.push(text);
    }
  }

  /** Met à jour les valeurs affichées */
  refresh(): void {
    const stock = this.resources.getAll();
    for (let i = 0; i < ALL_RESOURCES.length; i++) {
      const type = ALL_RESOURCES[i];
      const info = RESOURCE_INFO[type];
      const iconKey = SpriteRenderer.iconKey(getResourceIconId(type));
      const hasIcon = this.scene.textures.exists(iconKey);
      if (this.texts[i]) {
        this.texts[i].setText(hasIcon
          ? `${info.name}: ${stock[type]}`
          : `${info.emoji} ${info.name}: ${stock[type]}`);
      }
    }
  }
}
